import { FiPlayCircle } from "react-icons/fi";

function CourseSubSectionAccordion({ subSec }) {
  return (
    <div className="flex items-center gap-3 py-3 text-sm text-richblack-300 transition-colors duration-150 hover:text-richblack-100">
      <FiPlayCircle className="flex-shrink-0 text-base text-richblack-400" />
      <span className="flex-1 leading-snug">{subSec?.title}</span>
      {subSec?.timeDuration && (
        <span className="flex-shrink-0 text-xs text-richblack-500">
          {subSec.timeDuration}
        </span>
      )}
    </div>
  );
}

export default CourseSubSectionAccordion;
